import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { fetchFilters } from "./filterThunk"
import { IFilterState } from "./types"

const initialState: IFilterState = {
	inputs: [],
	total: 0,
	loading: false,
	error: null,
}

const filterSlice = createSlice({
	name: "filter",
	initialState,
	reducers: {
		setTotal: (state, action: PayloadAction<number>) => {
			state.total = action.payload
		},
	},
	extraReducers: builder => {
		builder.addCase(fetchFilters.pending, state => {
			state.loading = true
		})
		builder.addCase(fetchFilters.fulfilled, (state, action) => {
			state.inputs = action.payload.inputs
			state.total = action.payload.total
			state.loading = false
		})
		builder.addCase(fetchFilters.rejected, (state, action) => {
			state.error = action.error.message || "Не удалось получить фильтры"
			state.loading = false
		})
	},
})
export const { setTotal } = filterSlice.actions
export default filterSlice.reducer
